export default __webpack_public_path__ + "static/media/straight-ruler-blue.b8a600e2.svg";